import { IPoint } from 'framework/utils/math-utils';
import { IHexGridData } from 'js/bubbleCore/types';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop';
import { Hex } from 'js/bubbleCore/Hex';
import { gridOffsetToSpaceOffset } from 'js/bubbleCore/utils/gridOffsetToSpaceOffset';

export function spacePositionToGridHex<T>(x: number, y: number, grid: IHexGridData<T>, outHex?: Hex): Hex {
  const hex = outHex || new Hex(grid.type);
  const offset = gridOffsetToSpaceOffset(grid);
  hex.setFromPosition(x - offset.x, y - offset.y);
  return hex;
}

window.spacePositionToGridHex = spacePositionToGridHex;